(() => {
  const dialog = document.getElementById('zl-catalog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const triggers = document.querySelectorAll('[data-zl-catalog-open]');
  const roots = dialog.querySelector('.zl-catalog-roots');
  const content = dialog.querySelector('.zl-catalog-content');
  const main = dialog.querySelector('.zl-catalog-main');
  const search = dialog.querySelector('input');
  const back = dialog.querySelector('.zl-catalog-back');
  const backText = back.textContent;
  let data, pending, selected, opener, oldOverflow, currentPath = [], searching = false;
  const create = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text) el.textContent = text; return el; };
  const url = h => `${dialog.dataset.root.replace(/\/$/, '')}/collections/${encodeURIComponent(h)}`;
  const link = (h, cls, text) => { const el = create('a', cls, text || data.nodes[h].title); el.href = url(h); return el; };
  const allLink = h => link(h, 'zl-catalog-all', `${dialog.dataset.all} →`);
  function picture(h, small = false) {
    const frame = create('span', small ? 'zl-catalog-thumb' : 'zl-catalog-picture');
    const node = data.nodes[h];
    frame.setAttribute('aria-hidden', 'true');
    if (node.image) {
      const img = create('img'); img.src = small ? node.thumb || node.image : node.image;
      img.alt = ''; img.width = small ? 96 : 360; img.height = small ? 96 : 360;
      img.loading = 'lazy'; img.decoding = 'async'; frame.append(img);
    } else { frame.append(create('span', 'zl-catalog-placeholder', '▦')); }
    return frame;
  }
  function card(h, path) {
    const node = data.nodes[h]; const branch = node.groups.length && !path.includes(h);
    const el = branch ? create('button', 'zl-catalog-card') : link(h, 'zl-catalog-card', '');
    el.textContent = ''; el.dataset.handle = h;
    if (branch) { el.type = 'button'; el.addEventListener('click', () => choose(h, [...path, h], true)); }
    const label = create('span', 'zl-catalog-card-label', node.title);
    if (branch) { const arrow = create('span', 'zl-catalog-card-arrow', '›'); arrow.setAttribute('aria-hidden', 'true'); label.append(arrow); }
    el.append(picture(h), label); return el;
  }
  function renderGroups(groups, path) {
    const fragment = document.createDocumentFragment();
    groups.forEach(group => {
      const section = create('section', 'zl-catalog-section');
      if (group.title) section.append(create('h4', '', group.title));
      const list = create('div', 'zl-catalog-links');
      group.children.forEach(h => { if (data.nodes[h]) list.append(card(h, path)); });
      section.append(list); fragment.append(section);
    });
    return fragment;
  }
  function breadcrumbs(path) {
    const nav = create('nav', 'zl-catalog-breadcrumbs'); nav.setAttribute('aria-label', dialog.dataset.title);
    path.forEach((h, index) => {
      if (index) { const sep = create('span', '', '›'); sep.setAttribute('aria-hidden', 'true'); nav.append(sep); }
      if (index === path.length - 1) { const label = create('span', '', data.nodes[h].title); label.setAttribute('aria-current', 'page'); nav.append(label); }
      else { const button = create('button', '', data.nodes[h].title); button.type = 'button'; button.addEventListener('click', () => choose(h, path.slice(0, index + 1), true)); nav.append(button); }
    }); return nav;
  }
  function choose(h, path = [h], focus = false) {
    selected = h; currentPath = path; searching = false; search.value = '';
    roots.querySelectorAll('button').forEach(button => button.setAttribute('aria-current', String(button.dataset.handle === path[0])));
    const title = create('h3', '', data.nodes[h].title); title.tabIndex = -1;
    const heading = create('div', 'zl-catalog-category-heading'); heading.append(title, allLink(h));
    content.replaceChildren();
    if (path.length > 1) content.append(breadcrumbs(path));
    content.append(heading, renderGroups(data.nodes[h].groups, path));
    back.textContent = path.length > 1 ? `← ${data.nodes[path[path.length - 2]].title}` : backText;
    dialog.dataset.deep = String(path.length > 1); dialog.dataset.panel = 'detail'; main.scrollTop = 0;
    if (focus) title.focus({preventScroll:true});
  }
  function build() {
    roots.replaceChildren();
    data.groups.forEach(group => {
      roots.append(create('p', 'zl-catalog-group-title', group.title));
      group.children.forEach(h => {
        const button = create('button', 'zl-catalog-root'); button.type = 'button'; button.dataset.handle = h;
        const arrow = create('span', 'zl-catalog-root-arrow', '›'); arrow.setAttribute('aria-hidden', 'true');
        button.append(picture(h, true), create('span', 'zl-catalog-root-label', data.nodes[h].title), arrow);
        button.addEventListener('click', () => choose(h, [h], true)); roots.append(button);
      });
    });
    choose(data.groups[0].children[0]); dialog.dataset.panel = 'roots';
  }
  const normalize = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  function find() {
    if (!data) return;
    const q = normalize(search.value.trim());
    if (!q) { choose(selected, currentPath); return; }
    searching = true; dialog.dataset.panel = 'detail'; back.textContent = backText;
    const title = create('h3', '', dialog.dataset.results); title.setAttribute('aria-live', 'polite');
    content.replaceChildren(title);
    const crumbs = {};
    const visit = (h, path) => {
      if (!crumbs[h] || path.length < crumbs[h].length) crumbs[h] = path;
      if (path.includes(h)) return;
      data.nodes[h].groups.forEach(g => g.children.forEach(child => visit(child, [...path, h])));
    };
    data.groups.forEach(g => g.children.forEach(h => visit(h, [])));
    const matches = Object.entries(data.nodes).filter(([h,n]) => q.split(/\s+/).every(word => normalize(n.title).includes(word)));
    title.textContent += ` (${matches.length})`;
    const list = create('div', 'zl-catalog-links');
    matches.forEach(([h]) => list.append(card(h, crumbs[h] || []))); content.append(list);
    if (!matches.length) content.append(create('p', '', dialog.dataset.empty));
    main.scrollTop = 0;
  }
  async function open(event) {
    event.preventDefault(); opener = event.currentTarget;
    oldOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
    dialog.showModal(); triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    dialog.querySelector('.zl-catalog-close').focus();
    if (!data) {
      try {
        pending ||= fetch(dialog.dataset.source).then(r => { if (!r.ok) throw new Error('Catalog unavailable'); return r.json(); });
        data = await pending; build();
      } catch (_) {
        pending = null; roots.replaceChildren(); dialog.dataset.panel = 'roots';
        const fallback = create('a', 'zl-catalog-leaf', dialog.dataset.error); fallback.href = `${dialog.dataset.root.replace(/\/$/, '')}/collections`; roots.append(fallback);
      }
    }
  }
  triggers.forEach(trigger => trigger.addEventListener('click', open));
  dialog.querySelector('.zl-catalog-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = oldOverflow || ''; triggers.forEach(t => t.setAttribute('aria-expanded', 'false')); opener?.focus(); });
  back.addEventListener('click', () => {
    if (!searching && currentPath.length > 1) { const path = currentPath.slice(0, -1); choose(path[path.length - 1], path, true); }
    else { search.value = ''; if(data) choose(currentPath[0] || selected); dialog.dataset.panel = 'roots'; roots.querySelector(`[data-handle="${currentPath[0]}"]`)?.focus(); }
  });
  search.addEventListener('input', find);
})();
